// extracted by mini-css-extract-plugin
export default {"header":"Yu","fullPage":"Zu","closed":"av","minimize":"bv","redcircle":"cv","container":"ev","text":"fv","centered":"gv","escapex":"hv"};
    if(module.hot) {
      // 1738836192854
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  